import { ActivityEntityName } from '../../../../entities';
import { MergeField, MergeSchema, getSchema } from '../../decorators';

@MergeSchema({
    entity: ActivityEntityName.Utility
})
export class OtherMergeData {
    @MergeField()
    documentGeneratedDate: string;
}

export const OtherMergeDataSchema = getSchema(OtherMergeData);